<template>
    <div class="flex flex-col bg-gray-50 p-3">
        <h3 class="font-bold">{{ $t('orders.contact') }}</h3>
        <div class="flex items-center mt-2">
            <EnvelopeIcon class="w-4 h-4 mr-2">
            </EnvelopeIcon>
            <a href="mailto:{{ address.email}}" class="font-mono">{{ mail }}</a>
        </div>


        <div v-if="address.phone" class="flex items-center mt-2">
            <PhoneIcon class="w-4 h-4 mr-2">
            </PhoneIcon>
            <a href="tel:{{address.phone}}" class="font-mono">{{ address.phone }}</a>
        </div>
    </div>

</template>

<script>

import {EnvelopeIcon, PhoneIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['address'],
    components: {
        EnvelopeIcon,
        PhoneIcon
    },
    computed: {
        mail() {
            if(!this.address.email){
                return '';
            }

            if (this.address.email.length > 25) {
                return this.address.email.substr(0, 25) + "\u2026";
            }
            return this.address.email;
        }
    }
}
</script>

<style scoped>

</style>
